<div class="text-center mat-bg-primary pt-1 pb-1" style="position: relative;">
  <h6 class="m-0">NOTIFICAÇÕES</h6>
  <button mat-icon-button 
          style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%);" 
          (click)="closePanel()" 
          matTooltip="Fechar"
          aria-label="Fechar painel de notificações">
    <mat-icon style="font-size: 20px;">close</mat-icon>
  </button>
</div>
<mat-nav-list class="notification-list" role="list">
  <!-- Notification item -->
  <mat-list-item *ngFor="let n of notifications | async" class="notific-item" role="listitem" routerLinkActive="open">
    <mat-icon [color]="this.getColorByType(n.tipoNotificacao)" class="notific-icon mr-1">{{this.getIconByType(n.tipoNotificacao)}}</mat-icon>
    <ng-container *ngIf="isCompromisso(n); else notifDefault">
      <a [routerLink]="n.outrosDados" (click)="closePanel()">
        <div class="mat-list-text">
          <h4 class="message">{{n.titulo}}</h4>
          <small class="time text-muted" *ngIf="getCompromissoResponsavel(n)">👤 {{getCompromissoResponsavel(n)}}</small>
          <small class="time text-muted">
            Prazo: {{n.inicio | date:'dd/MM/yyyy'}}<span *ngIf="getCompromissoHorario(n)"> · ⏰ {{getCompromissoHorario(n)}}</span>
          </small>
        </div>
      </a>
    </ng-container>
    <ng-template #notifDefault>
      <a (click)="$event.preventDefault();openPopUp(n)">
        <div class="mat-list-text">
          <h4 class="message"><span *ngIf="n.fromInfokaw" [matTooltip]="'infokaw'"> * </span> {{n.titulo}}</h4>
          <small class="time text-muted">{{n.inicio | date:'dd/MM/yyyy'}}</small>
        </div>
      </a>
    </ng-template>
  </mat-list-item>
  <mat-list-item *ngIf="this.notificPanel.totalNotif===0" class="notific-item" role="listitem" routerLinkActive="open">
    <mat-icon [color]="'primary'" class="notific-icon mr-1">info</mat-icon>
      <div class="mat-list-text">
        <h4 class="message">Nenhuma Notificação</h4>
      </div>
  </mat-list-item>
</mat-nav-list>
<div class="text-center mt-1" *ngIf="this.notificPanel.totalNotif>0">
  <small><a href="#" (click)="clearAll($event)">{{'CLEAR_NOTIFICATION' | translate}}</a></small>
</div>